import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useStateSelector } from '../../../store/selectors';
import {
    selectTransactionDocuments,
    selectTransactionDocumentsLoading,
    selectTransactionDocumentsRequested,
} from '../../../slices/marketplace/transaction-documents/transaction-documents.slice';
import { GetTransactionDocuments } from '../../../slices/marketplace/transaction-documents/thunks/get-transaction-documents.thunk';

export const useTransactionDocuments = (engagementId: number) => {
    const dispatch = useDispatch();
    const transactionDocuments = useStateSelector((state) =>
        selectTransactionDocuments(state, engagementId)
    );
    const isLoading = useStateSelector(selectTransactionDocumentsLoading);
    const alreadyRequested = useStateSelector((state) =>
        selectTransactionDocumentsRequested(state, engagementId)
    );

    useEffect(() => {
        if (!engagementId) {
            return;
        }
        if (transactionDocuments) {
            (dispatch as any)(GetTransactionDocuments(engagementId));
            return;
        }
        if (isLoading || alreadyRequested) {
            return;
        }
        (dispatch as any)(GetTransactionDocuments(engagementId));
    }, [engagementId]);

    return { transactionDocuments, isLoading };
};
